/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React from "react";
import ReactRouterPropTypes from "react-router-prop-types";
import { Route, withRouter } from "react-router-dom";
import AgentConsoleSettingsPage from "./pages/AgentConsoleSettingsPage";
import UserManagementPage from "./pages/UserManagementPage";
import IntegrationsPage from "./pages/IntegrationsPage";
import AgentExtensionsPage from "./pages/AgentExtensionsPage";
import QueueManagementPage from "./pages/QueueManagementPage";
import { ReportingConfigPage } from "./pages/ReportingConfigPage";

const Module = ({ match }) => {
	return (
		<>
			<Route exact path={match.url}>
				<AgentConsoleSettingsPage />
			</Route>
			<Route path={`${match.url}/agentConsole`}>
				<AgentConsoleSettingsPage />
			</Route>
			<Route path={`${match.url}/userManagement`}>
				<UserManagementPage />
			</Route>
			<Route path={`${match.url}/integrations`}>
				<IntegrationsPage />
			</Route>
			<Route path={`${match.url}/agentExtensions`}>
				<AgentExtensionsPage />
			</Route>
			<Route path={`${match.url}/queues/:queueId?`}>
				<QueueManagementPage />
			</Route>
			<Route path={`${match.url}/reportingConfiguration`}>
				<ReportingConfigPage />
			</Route>
		</>
	);
};

Module.propTypes = {
	match: ReactRouterPropTypes.match.isRequired,
};

export default withRouter(Module);
